import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography
} from "@mui/material";
import { styled } from "@mui/system";
import { useEffect } from "react";
import { NumericFormat } from "react-number-format";

const StyledTextField = styled(TextField)({
  minWidth: "80px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#E9EAEC",
    borderRadius: "10px"
  },
  "& .MuiInputBase-root.Mui-disabled": {
    backgroundColor: "rgb(255, 255, 255)",
    borderColor: "rgb(179, 179, 179)",
    outline: "none",
    "& fieldset": {
      borderColor: "rgb(179, 179, 179)",
      borderWidth: "0.5px"
    }
  }
});

export const Section1 = ({
  formState,
  handleChange,
  handleSectionComplete,
  reportId,
  isEditingEnabled
}) => {
  useEffect(() => {
    const categories = [
      "with_letter",
      "returned_to_world",
      "deceased",
      "unknown_reason",
      "total_resigned"
    ];

    // Calculate all totals in one go to batch the updates
    const updates = categories.reduce((acc, category) => {
      const male = Number(formState.resignedMembers[category].male) || 0;
      const female = Number(formState.resignedMembers[category].female) || 0;
      const total = male + female;

      if (total !== formState.resignedMembers[category].total) {
        acc[category] = {
          ...formState.resignedMembers[category],
          total
        };
      }
      return acc;
    }, {});

    // Calculate total_resigned by summing other categories
    const totalResignedMale = [
      "with_letter",
      "returned_to_world",
      "deceased",
      "unknown_reason"
    ].reduce((sum, category) => {
      return sum + (Number(formState.resignedMembers[category].male) || 0);
    }, 0);

    const totalResignedFemale = [
      "with_letter",
      "returned_to_world",
      "deceased",
      "unknown_reason"
    ].reduce((sum, category) => {
      return sum + (Number(formState.resignedMembers[category].female) || 0);
    }, 0);

    const totalResignedTotal = totalResignedMale + totalResignedFemale;

    updates.total_resigned = {
      male: totalResignedMale,
      female: totalResignedFemale,
      total: totalResignedTotal
    };

    // Only update if there are changes
    if (Object.keys(updates).length > 0) {
      // Calculate grand total
      // const grandTotal = categories.reduce((sum, category) => {
      //   return (
      //     sum +
      //     (updates[category]?.total ||
      //       formState.resignedMembers[category].total ||
      //       0)
      //   );
      // }, 0);

      // Batch all updates together
      handleChange("resignedMembers", "all", {
        ...updates,
        total_in_branches: totalResignedTotal
      });
    }
  }, [
    formState.resignedMembers.with_letter.male,
    formState.resignedMembers.with_letter.female,
    formState.resignedMembers.returned_to_world.male,
    formState.resignedMembers.returned_to_world.female,
    formState.resignedMembers.deceased.male,
    formState.resignedMembers.deceased.female,
    formState.resignedMembers.unknown_reason.male,
    formState.resignedMembers.unknown_reason.female,
    formState.resignedMembers.total_resigned.male,
    formState.resignedMembers.total_resigned.female
  ]);

  return (
    <Stack spacing={2}>
      <TableContainer sx={{ overflowX: "auto" }}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell></TableCell>
              <TableCell align="center">ወንድ</TableCell>
              <TableCell align="center">ሴት</TableCell>
              <TableCell align="center">ድምር</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>በሸኚ ደብዳቤ የለቀቁ ምዕመናን ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.resignedMembers.with_letter.male}
                  onValueChange={values => {
                    handleChange("resignedMembers", "with_letter", {
                      ...formState.resignedMembers.with_letter,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.resignedMembers.with_letter.female}
                  onValueChange={values => {
                    handleChange("resignedMembers", "with_letter", {
                      ...formState.resignedMembers.with_letter,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.resignedMembers.with_letter.total}
                  inputProps={{
                    readOnly: true
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ወደ ዓለም የተመለሱ ምዕመናን ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.resignedMembers.returned_to_world.male}
                  onValueChange={values => {
                    handleChange("resignedMembers", "returned_to_world", {
                      ...formState.resignedMembers.returned_to_world,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.resignedMembers.returned_to_world.female}
                  onValueChange={values => {
                    handleChange("resignedMembers", "returned_to_world", {
                      ...formState.resignedMembers.returned_to_world,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.resignedMembers.returned_to_world.total}
                  inputProps={{
                    readOnly: true
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ከዚህ ዓለም በሞት የተለዩ ምዕመናን ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.resignedMembers.deceased.male}
                  onValueChange={values => {
                    handleChange("resignedMembers", "deceased", {
                      ...formState.resignedMembers.deceased,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.resignedMembers.deceased.female}
                  onValueChange={values => {
                    handleChange("resignedMembers", "deceased", {
                      ...formState.resignedMembers.deceased,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.resignedMembers.deceased.total}
                  inputProps={{
                    readOnly: true
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ባልታወቀ ምክንያት የለቀቁ ምዕመናን ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.resignedMembers.unknown_reason.male}
                  onValueChange={values => {
                    handleChange("resignedMembers", "unknown_reason", {
                      ...formState.resignedMembers.unknown_reason,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.resignedMembers.unknown_reason.female}
                  onValueChange={values => {
                    handleChange("resignedMembers", "unknown_reason", {
                      ...formState.resignedMembers.unknown_reason,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.resignedMembers.unknown_reason.total}
                  inputProps={{
                    readOnly: true
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ሪፖርቱ በሚሸፍንበት ጊዜ የተቀነሱ ምዕመናን ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.resignedMembers.total_resigned.male}
                  inputProps={{
                    readOnly: true
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.resignedMembers.total_resigned.female}
                  inputProps={{
                    readOnly: true
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.resignedMembers.total_resigned.total}
                  inputProps={{
                    readOnly: true
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography>
                  ሪፖርቱ በሚሸፍንበት ጊዜ የተቀነሱ ጠቅላላ ምዕመናን ብዛት ድምር
                </Typography>
              </TableCell>
              <TableCell colSpan={3}>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.resignedMembers.total_in_branches}
                  inputProps={{
                    readOnly: true
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {!reportId && (
        <Stack alignItems="flex-start">
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSectionComplete(1)}
          >
            ቀጥል
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
